import React, { useEffect, useState } from "react";
import LabelController from "../../../atoms/Label/LabelController";
import { LEAD_TYPE } from "../../../../pages/leads-management/models/ILead";
export enum LeadTypeEnum {
  Business = "Business",
  Consumer = "Consumer",
}

interface LeadTypeToggleProps {
  onChange: (value: LEAD_TYPE) => void;
  defaultValue?: LEAD_TYPE;
}

const LeadTypeToggle: React.FC<LeadTypeToggleProps> = ({
  onChange,
  defaultValue = LeadTypeEnum.Business,
}) => {
  const [leadType, setLeadType] = useState<LEAD_TYPE>(() => {
    return LEAD_TYPE.BUSINESS;
  });

  useEffect(() => {
    localStorage.setItem("leadType", leadType);
    onChange(leadType);
  }, [leadType, onChange]);

  return (
    <div className="toggle-lead-type box-container">
      <LabelController label={"Lead Type"} />
      <div className="toggle-section">
        <button
          type="button"
          onClick={() => setLeadType(LEAD_TYPE.BUSINESS)}
          className={leadType === LEAD_TYPE.BUSINESS ? "active" : ""}
        >
          Business
        </button>
        <button
          type="button"
          onClick={() => setLeadType(LEAD_TYPE.CUSTOMER)}
          className={leadType === LEAD_TYPE.CUSTOMER ? "active" : ""}
        >
          Consumer
        </button>
      </div>
    </div>
  );
};

export default LeadTypeToggle;
